// @ts-nocheck
/* eslint-disable */
import * as registry from '../../registry.js'
/**
* @param {{  }} i
*/
export const shareButton_defaultMessage = (i) => `You're invited to my event! 🤗
All details are in the link, please RSVP there so I can plan better and know who's coming/not coming etc.
`